import type { QueryClient } from '@tanstack/react-query';
import { useArticleTypeStore } from '../stores/articleTypeStore';
import { useSystemStore } from '../stores/systemStore';
import { useUserStore } from '../stores/userStore';

export const logoutService = {
  clearAuthTokens: () => {
    localStorage.removeItem('auth0.is.authenticated');
    localStorage.removeItem('auth0.claims');
    localStorage.removeItem('auth0.expires_at');
    localStorage.removeItem('auth0.id_token');
    localStorage.removeItem('auth0.refresh_token');
  },

  clearAppState: (queryClient: QueryClient) => {
    // Clear localStorage
    localStorage.clear();
    sessionStorage.clear();

    // Clear React Query cache
    queryClient.clear();

    // Reset Zustand stores
    useSystemStore.setState({
      systems: [],
      variants: [],
      isLoading: false,
      error: null,
      lastFetched: null,
    });

    useArticleTypeStore.setState({
      articleTypes: [],
      isLoading: false,
      error: null,
      lastFetchTimestamp: null,
    });

    useUserStore.setState({
      state: 'loading',
      user: null,
      preferences: {},
      isLoading: false,
      error: null,
      isCheckingState: false,
    });
  },

  logout: (queryClient: QueryClient) => {
    logoutService.clearAppState(queryClient);
    window.location.href = '/';
  },

  logoutForApiError: () => {
    logoutService.clearAuthTokens();
    window.location.href = '/';
  },
};
